import { useContext } from "react";
import TenantContext, { TenantContextInterface } from "./tenant-context";

const useTenant = (): TenantContextInterface => useContext(TenantContext);

export default useTenant;
